import { createSelector } from 'reselect';
import { getState } from '../rootSelector';
export const getSeatMapAdditionalServices = createSelector(getState, state => state.additionalServices);
